import React from 'react'
import trash from '../../../../../assets/assesses/trash.svg'
import check from '../../../../../assets/assesses/check.svg'
import cross from '../../../../../assets/assesses/cross.svg'
import axios from 'axios'

interface ValidationType {
  situation: string
  id: number
  onUpdate: () => void
}

const Validation = ({ situation, id, onUpdate }: ValidationType) => {
  const changeStatus = (id: number, type: string): void => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/user/${id}`, {
        approved: type,
      })
      .then((res) => {
        console.log(res)
        onUpdate()
      })
      .catch((err) => {
        console.log(err)
      })
  }
  
  if(situation === 'approved'){
    return(
      <>
        <img src={check} alt="check" className="disabled" />
        <img src={trash} alt="trash" onClick={() => changeStatus(id, 'blocked')} />
      </>
    )
  }
  if(situation == 'pendent' || situation === 'pending'){
    return(
      <>
        <img src={check} alt="check" onClick={() => changeStatus(id, 'approved')} />
        <img src={cross} alt="cross" onClick={() => changeStatus(id, 'blocked')} />
      </>
    )
  }
  if(situation === 'blocked'){
    return(
      <>
        <img src={check} alt="check" onClick={() => changeStatus(id, 'approved')} />
      </>
    )
  }
  return null;
}

export default Validation
